var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-subscriptions"),
          _c("w-info", {
            staticClass: "mt",
            attrs: {
              text: _vm.$ct("invoices-available"),
              "ico-lib": "fas",
              ico: "info-circle",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }